module.exports = __webpack_public_path__ + "static/media/forward_green.a56dfafa.svg";